if (!customElements.get('montaren-polo-reviews')) {
  customElements.define('montaren-polo-reviews', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController(); const signal = this.abort.signal;
      this.track = this.querySelector('[data-review-track]');
      this.cards = [...this.querySelectorAll('[data-review-card]')];
      this.prev = this.querySelector('[data-review-prev]'); this.next = this.querySelector('[data-review-next]');
      this.dots = this.querySelector('[data-review-dots]'); this.pause = this.querySelector('[data-review-pause]');
      if (!this.track || !this.cards.length) return;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.reduced.matches || Boolean(window.Shopify?.designMode);
      this.positions = []; this.index = 0;
      this.prev.addEventListener('click', () => { this.stop(); this.go(this.index - 1); }, {signal});
      this.next.addEventListener('click', () => { this.stop(); this.go(this.index + 1); }, {signal});
      this.track.addEventListener('scroll', () => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(() => this.sync()); }, {signal, passive:true});
      this.track.addEventListener('pointerdown', () => this.stop(), {signal, passive:true});
      this.track.addEventListener('keydown', e => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
        e.preventDefault(); this.stop(); this.go(e.key === 'Home' ? 0 : e.key === 'End' ? this.positions.length - 1 : this.index + (e.key === 'ArrowRight' ? 1 : -1));
      }, {signal});
      this.pause?.addEventListener('click', () => { this.paused = !this.paused; this.schedule(); }, {signal});
      this.addEventListener('mouseenter', () => clearTimeout(this.timer), {signal});
      this.addEventListener('mouseleave', () => this.schedule(), {signal});
      this.addEventListener('focusin', () => clearTimeout(this.timer), {signal});
      this.addEventListener('focusout', () => this.schedule(), {signal});
      document.addEventListener('visibilitychange', () => this.schedule(), {signal});
      document.addEventListener('shopify:block:select', e => {
        const card = e.target.closest('[data-review-card]');
        if (!card || !this.contains(card)) return;
        this.stop(); this.track.scrollTo({left:card.offsetLeft-this.cards[0].offsetLeft,behavior:'auto'});
      }, {signal});
      this.reduced.addEventListener('change', () => { if(this.reduced.matches)this.stop(); }, {signal});
      this.observer?.disconnect(); this.observer = new ResizeObserver(() => this.measure()); this.observer.observe(this.track);
      this.measure(); this.schedule();
    }
    measure() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const first = this.cards[0].offsetLeft;
      this.positions = [...new Set(this.cards.map(c => Math.round(Math.min(max, Math.max(0,c.offsetLeft-first)))))];
      if(Math.abs(this.positions.at(-1)-max)>2)this.positions.push(max);
      this.dots.replaceChildren(...this.positions.map((_,i) => {
        const b=document.createElement('button');b.type='button';b.className='m-polo-reviews__dot';b.setAttribute('aria-label',`Go to review position ${i+1}`);
        b.addEventListener('click',()=>{this.stop();this.go(i);});return b;
      }));
      this.querySelector('[data-review-nav]').hidden=this.positions.length<2;
      this.sync();
    }
    sync() {
      const pos=this.track.scrollLeft;
      this.index=this.positions.reduce((best,v,i)=>Math.abs(v-pos)<Math.abs(this.positions[best]-pos)?i:best,0);
      this.prev.disabled=this.index===0;this.next.disabled=this.index===this.positions.length-1;
      [...this.dots.children].forEach((b,i)=>b.setAttribute('aria-current',String(i===this.index)));
    }
    go(i) { const n=Math.max(0,Math.min(this.positions.length-1,i));this.track.scrollTo({left:this.positions[n],behavior:this.reduced.matches?'auto':'smooth'}); }
    stop() { this.paused=true;this.schedule(); }
    schedule() {
      clearTimeout(this.timer);
      if(this.pause){this.pause.textContent=this.paused?'Play reviews':'Pause reviews';this.pause.setAttribute('aria-pressed',String(!this.paused));}
      if(this.paused||document.hidden||this.reduced.matches||this.matches(':hover')||this.contains(document.activeElement)||this.positions.length<2)return;
      this.timer=setTimeout(()=>{this.go((this.index+1)%this.positions.length);this.schedule();},Number(this.dataset.interval||6)*1000);
    }
    disconnectedCallback() {this.abort?.abort();this.observer?.disconnect();clearTimeout(this.timer);cancelAnimationFrame(this.frame);}
  });
}
